import makeTable from "./makeTable";
import BASE_WIDTH_COLUMNS from "./constants/baseWidthColumns";

const { DATE, COMPANIES, TAXI_SERVICE, NAME } = BASE_WIDTH_COLUMNS;

export enum ColumnId {
	TRANSACTION_ID = "transactionId",
	CREATED_AT = "createdAt",
	CLIENT_NAME = "clientName",
	TRANSACTION_AMOUNT = "transactionAmount",
	TRANSACTION_AMOUNT_COMMISSION = "transactionAmountCommission",
	REMOUNT_TRANSACTION_TYPE = "remountTransactionType",
	STATUS = "status",
	STATUS_DESCRIPTION = "statusDescription",
	CALLSIGN = "callSign",
	EXECUTOR_FULL_NAME = "executorFullName",
	AMOUNT_THAT_CAME = "amountThatCame",
	AMOUNT_DRIVER_BALANCE = "amountDriverBalance",
	AMOUNT_FROM_CLIENT = "amountFromClient",
	PAYMENT_SYSTEM = "paymentSystem",
	TRANSACTION_TYPE = "transactionType",
	COMPANY = "company",
	TAXI_SERVICE = "taxiService",
	ORDER_NUMBER = "orderNumber",
}

export const translationTablePath =
	"pages.mainPage.pages.archives.tabs.bankTransactions.content.columns.";

export const allColumns: ColumnId[] = Object.values(ColumnId);

export const defaultColumns: ColumnId[] = allColumns;

const archivesBankTransactions = makeTable({
	allIds: Object.values(ColumnId),
	i18tPath: (id) => `${translationTablePath}${id}`,
	defaultIds: defaultColumns,
	initialSortMethod: {
		column: ColumnId.CREATED_AT,
		type: "asc",
	},
	initialWidths: {
		[ColumnId.TRANSACTION_ID]: 150,
		[ColumnId.CREATED_AT]: DATE,
		[ColumnId.CLIENT_NAME]: NAME,
		[ColumnId.TRANSACTION_AMOUNT]: 150,
		[ColumnId.TRANSACTION_AMOUNT_COMMISSION]: 200,
		[ColumnId.REMOUNT_TRANSACTION_TYPE]: 160,
		[ColumnId.STATUS]: 120,
		[ColumnId.STATUS_DESCRIPTION]: 200,
		[ColumnId.CALLSIGN]: 160,
		[ColumnId.EXECUTOR_FULL_NAME]: 200,
		[ColumnId.AMOUNT_THAT_CAME]: 200,
		[ColumnId.AMOUNT_DRIVER_BALANCE]: 200,
		[ColumnId.AMOUNT_FROM_CLIENT]: 200,
		[ColumnId.PAYMENT_SYSTEM]: 200,
		[ColumnId.TRANSACTION_TYPE]: 200,
		[ColumnId.COMPANY]: COMPANIES,
		[ColumnId.TAXI_SERVICE]: TAXI_SERVICE,
		[ColumnId.ORDER_NUMBER]: 160,
	},
	initialResizable: Object.fromEntries(
		Object.values(ColumnId).map((id) => [id, true]),
	) as Record<ColumnId, boolean>,
	initialSortable: {
		[ColumnId.TRANSACTION_ID]: true,
		[ColumnId.CREATED_AT]: true,
		[ColumnId.CLIENT_NAME]: false,
		[ColumnId.TRANSACTION_AMOUNT]: false,
		[ColumnId.TRANSACTION_AMOUNT_COMMISSION]: false,
		[ColumnId.REMOUNT_TRANSACTION_TYPE]: false,
		[ColumnId.STATUS]: true,
		[ColumnId.STATUS_DESCRIPTION]: true,
		[ColumnId.CALLSIGN]: false,
		[ColumnId.EXECUTOR_FULL_NAME]: false,
		[ColumnId.AMOUNT_THAT_CAME]: false,
		[ColumnId.AMOUNT_DRIVER_BALANCE]: false,
		[ColumnId.AMOUNT_FROM_CLIENT]: false,
		[ColumnId.PAYMENT_SYSTEM]: false,
		[ColumnId.TRANSACTION_TYPE]: false,
		[ColumnId.COMPANY]: false,
		[ColumnId.TAXI_SERVICE]: false,
		[ColumnId.ORDER_NUMBER]: false,
	},
});

export default archivesBankTransactions;
